import React, { useEffect, useState } from 'react';
import s from './s.module.less';

import SpecificSpecNConditions from 'components/HelloKlarityFormComponents/SpecificSpecNConditions';
import { EditModuleEnum } from 'types/practiceFront';
import { ISaveSpecificInfoReqListInput } from 'types/operation';

interface IProps {
    onSubmit?: (data: any, field: EditModuleEnum, callback?: () => void) => void;
    specificConditionDetail?: ISaveSpecificInfoReqListInput;
}

const SepecificSpecialties = ({
    onSubmit,
    specificConditionDetail,
}: IProps) => {
    const [specialtyHighlightListData, setSpecialtyHighlightList] = useState<string[]>([]);

    useEffect(() => {
        const { specialtyHighlight } = specificConditionDetail || {};
        setSpecialtyHighlightList(specialtyHighlight || []);
    }, [setSpecialtyHighlightList, specificConditionDetail]);

    const specialtiesApproaches = {
        specialtyList: specificConditionDetail?.specialty,
        conditionTreatedList: specificConditionDetail?.conditionTreated,
    };
    return (
        <div className={s.wrap}>
            <div className={s.editItem}>
                <SpecificSpecNConditions
                    specialtyHighlightList={specialtyHighlightListData}
                    initFormValue={specialtiesApproaches}
                    onSubmit={onSubmit}
                />
            </div>
        </div>
    );
};

export default SepecificSpecialties;
